import { Button, ButtonProps, Flex, Text, Icon } from "@chakra-ui/react";
import { FC } from "react";

interface OutlineButtonProps extends ButtonProps {
  icon: React.ElementType;
  text: string;
  variant?: "primary" | "secondary" | "noStyle";
}

const OutlineButton: FC<OutlineButtonProps> = ({
  icon,
  text,
  variant = "primary",
  ...props
}) => {
  const bgColor = "transparent";
  const textColor =
    variant === "secondary" ? "status.error" : "brand.primary.DEFAULT";
  const hoverBgColor =
    variant === "primary"
      ? "brand.primary.DEFAULT"
      : variant === "secondary"
      ? "status.error"
      : variant === "noStyle"
      ? "transparent"
      : "default.bg";
  const hoverTextColor = variant === "noStyle" ? "brand.primary.700" : "white";

  return (
    <Button
      variant="outline"
      borderColor="border.default"
      bg={bgColor}
      boxShadow="none"
      color={textColor}
      _hover={{
        bg: hoverBgColor,
        color: hoverTextColor,
        borderColor: hoverBgColor,
      }}
      _active={{
        bg: hoverBgColor,
        color: hoverTextColor,
        borderColor: hoverBgColor,
      }}
      _disabled={{
        bg: "#E1E6EC",
        color: "#94A3B8",
      }}
      borderRadius="xl"
      borderWidth="1px"
      py={variant === "noStyle" ? "0" : "6px"}
      px={"20px"}
      {...props}
    >
      <Flex alignItems={"center"} gap={1}>
        <Flex align="center" gap={1}>
          <Icon as={icon} color="inherit" h={5} w={5} verticalAlign="middle" />
          <Text color="inherit" fontSize="inherit" lineHeight="1">
            {text}
          </Text>
        </Flex>
      </Flex>
    </Button>
  );
};

export default OutlineButton;
